import React, { Component, createRef } from 'react';
import Style from './FJVideoBox.module.less';
import FJResourceItemLoading from '../../FJResourceItemLoading/FJResourceItemLoading.jsx';
import ReloadIcon from '../../../../assets/svg/reload.svg?react';
import FJUtil from '../../../../util/FJUtil.js';
import FJCanvasUtil from '../../../../util/FJCanvasUtil.js';

class FJVideoBox extends Component {
    constructor(props) {
        super(props);
        this.videoRef = createRef();
        this.containerRef = createRef();
        this.canvasRef = createRef();
        this.state = {
            isLoaded: false,
            videoSize: { width: '100%', height: '100%' },
            isShowLoading: true,
            isError: false,
            isWaiting: true,
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.fitVideoSize);
        setTimeout(() => {
            this.fitVideoSize();
            this.setState({ isWaiting: false });
        }, 500);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.fitVideoSize);
    }

    componentDidUpdate(preProps) {
        let preViewSize = preProps.viewSize;
        let viewSize = this.props.viewSize;
        let preRotation = preProps.rotation;
        let rotation = this.props.rotation;
        if (
            viewSize &&
            (viewSize.width !== preViewSize.width || viewSize.height !== preViewSize.height || preRotation !== rotation)
        ) {
            this.fitVideoSize();
        }

        if (this.props.src !== preProps.src) {
            this.setState({ isShowLoading: true, isLoaded: false, isError: false, isWaiting: false });
        }

        if (this.props.isShowTransparentBG) {
            this.drawTransparentBackground();
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.props.src !== nextProps.src) {
            nextState.isShowLoading = true;
            nextState.isLoaded = false;
            nextState.isError = false;
            nextState.videoSize = { width: '100%', height: '100%' };
            nextState.isWaiting = true;
        }
        return true;
    }

    requestFullscreen() {
        this.containerRef.current.requestFullscreen();
    }

    drawTransparentBackground = () => {
        if (this.canvasRef.current) {
            const canvas = this.canvasRef.current;
            const rect = canvas.getBoundingClientRect();
            canvas.width = rect.width;
            canvas.height = rect.height;
            const ctx = canvas.getContext('2d');
            FJCanvasUtil.drawTransparentBackground(ctx, rect.width, rect.height, 10);
        }
    };

    fitVideoSize = () => {
        let { viewSize, rotation = 0, ratio } = this.props;

        if (!viewSize) {
            viewSize = this.containerRef.current.parentNode.getBoundingClientRect();
        }

        // let { videoWidth, videoHeight } = this.videoRef.current;
        const videoWidth = 1920;
        const videoHeight = videoWidth / ratio;

        let oriSize = {
            width: rotation === 90 || rotation === 270 ? videoHeight : videoWidth,
            height: rotation === 90 || rotation === 270 ? videoWidth : videoHeight,
        };
        oriSize.width = oriSize.width === 0 ? 1 : oriSize.width;
        oriSize.height = oriSize.height === 0 ? 1 : oriSize.height;

        let size = FJUtil.fitSize(oriSize, viewSize, true);
        this.setState({
            videoSize: {
                width: rotation === 90 || rotation === 270 ? size.height : size.width,
                height: rotation === 90 || rotation === 270 ? size.width : size.height,
            },
        });
    };

    isLoaded = () => {
        return this.state.isLoaded;
    };

    seek = time => {
        if (this.videoRef.current) {
            this.videoRef.current.currentTime = time;
        }
    };

    play = () => {
        this.videoRef.current.play();
        if (this.props.onPlay) {
            this.props.onPlay();
        }
    };

    pause = () => {
        try {
            this.videoRef.current.pause();
        } catch (e) {
            console.log(e);
        }
    };
    getCurrentTime = () => {
        return this.videoRef.current.currentTime;
    };

    getVideo = () => {
        return this.videoRef.current;
    };

    setVolume = value => {
        this.videoRef.current.volume = value;
    };

    getVolume = () => {
        return this.videoRef.current.volume;
    };

    onLoadStart = () => {
        this.setState({ isLoaded: false, isShowLoading: true });
        if (this.props.onLoadStart) {
            this.props.onLoadStart();
        }
    };
    onLoadedData = () => {
        // TODO: 存在缓存视频加载过快会导致界面适配错误
        setTimeout(() => {
            this.setState({ isLoaded: true, isShowLoading: false });
            this.fitVideoSize();
        }, 200);
        if (this.props.onLoadedData) {
            this.props.onLoadedData();
        }
    };

    onError = () => {
        this.setState({ isError: true, isShowLoading: false });
        if (this.props.onError) {
            this.props.onError();
        }
    };

    onSeeked = () => {
        if (this.props.onSeeked) {
            this.props.onSeeked();
        }
    };

    onPlaying = () => {
        if (this.props.onPlaying) {
            this.props.onPlaying();
        }
    };

    onEnded = () => {
        if (this.props.onEnded) {
            this.props.onEnded();
        }
    };

    render() {
        let {
            src,
            viewSize,
            videoStyle = {},
            onClick,
            autoPlay,
            rotation = 0,
            children,
            renderBottom = () => {},
            onReload,
            style,
            isFullScreen,
        } = this.props;
        let { isLoaded, isShowLoading, videoSize, isError, isWaiting } = this.state;

        return (
            <>
                <div
                    className={Style.container}
                    onClick={onClick}
                    style={{
                        width: isWaiting ? '100%' : videoSize ? videoSize.width : '100%',
                        height: isWaiting ? '100%' : videoSize ? videoSize.height : '100%',
                        ...style,
                    }}
                    ref={this.containerRef}
                >
                    <canvas ref={this.canvasRef} className={Style.canvas} />
                    {src && (
                        <video
                            className={Style.content}
                            autoPlay={autoPlay}
                            src={src}
                            onLoadedData={this.onLoadedData}
                            onLoadStart={this.onLoadStart}
                            onSeeked={this.onSeeked}
                            onError={this.onError}
                            onPlaying={this.onPlaying}
                            onEnded={this.onEnded}
                            ref={this.videoRef}
                            style={{
                                transform: 'rotate(' + rotation + 'deg)',
                                opacity: isLoaded && !isShowLoading && !isWaiting ? 1 : 0,
                                ...videoStyle,
                                objectFit: isFullScreen ? 'contain' : 'cover',
                            }}
                        />
                    )}
                    {((isShowLoading && !isLoaded) || isWaiting) && <FJResourceItemLoading />}
                    {isError && !isWaiting && (
                        <div className={Style.retry_box}>
                            <ReloadIcon className={Style.reload_icon} onClick={onReload} />
                        </div>
                    )}
                    {!isWaiting && children}
                </div>
                {!isWaiting && renderBottom(videoSize.width || '100%')}
            </>
        );
    }
}

export default FJVideoBox;
